// api should be here
import { http } from '@/utils/http';
import { isWeiXin } from '@/common/ts/common';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2021project/q1/2021geely/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getRules = () => {
  return http.get(`${urlPrefix}rules`);
};
const get4SList = () => {
  return http.get(`${urlPrefix}4s-list`);
};
const save = (data: any) => {
  return http.post(`${urlPrefix}save`, qs.stringify(data));
};
const userInfo = (id?: string) => {
  return http.post(
    `${urlPrefix}user-info`,
    qs.stringify({
      unionid: id,
    }),
  );
};
// 兑换影票
const convert = (shopId: string, id?: string) => {
  return http.post(
    `${urlPrefix}exchange`,
    qs.stringify({
      shop_id: shopId,
      unionid: id,
    }),
  );
};
const getList = () => {
  return http.get(`${urlPrefix}head-list`);
};

const share = (context: any) => {
  let shareUrl = window.location.href;
  shareUrl = shareUrl.replace('rules', 'home');
  shareUrl = shareUrl.replace('success-apply', 'home');
  shareUrl = shareUrl.replace('apply', 'home');

  context.$appShareInfo({
    title: '吉利请你看电影',
    url: shareUrl,
    subtitle: '就地过年，吉利请你看电影',
    classId: -1,
    id: -1,
    image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    type: 3,
  });
  // 微信分享
  if (isWeiXin()) {
    context.$wxShareInfo({
      title: '吉利请你看电影',
      subtitle: '就地过年，吉利请你看电影',
      url: shareUrl,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
};
export {
  getBaseInfo,
  getRules,
  share,
  get4SList,
  save,
  userInfo,
  convert,
  getList,
};
